module.exports = __webpack_public_path__ + "static/media/logo-footer.dd4d87ef.png";